var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container",class:{ active: _vm.active }},[_c('div',{staticClass:"loading-frame"},[_c('div',{staticClass:"loading",class:[_vm.direction],style:({ color: _vm.color, fontSize: _vm.fontSize })},[_c('i',{staticClass:"fas fa-circle-notch fa-spin"}),_c('label',[_vm._v(_vm._s(_vm.text))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }